module.exports = __webpack_public_path__ + "media/images/brand/app_logo_full_original-0d5be0eeef4017245e68fab0b32e6f50.png";